// extracted by mini-css-extract-plugin
export var editButton = "_p4-0";